import graphql from 'api/graphql'
import { oauthTokenSelector } from 'selectors/app'
import { groupsQuery } from 'api/groups'
import { BootstrapLoader } from 'util/bootstrap'
import requestAction from './requestAction'
import successAction from './successAction'
import failAction from './failAction'

export default function loader() {
  return new BootstrapLoader(
    'groups',
    requestAction,
    successAction,
    failAction,
    getState => {
      return graphql(oauthTokenSelector(getState()), groupsQuery())
    }
  )
}
